import { isExpired } from "react-jwt";
import { useCallback, useEffect, useRef, useState } from "react";

export const serverurl =  'https://djamnazi.alwaysdata.net/app/';
//export const serverurl = 'https://localhost:8000/app/';

function JsonParse(response)
{
   try
   {
      return response.json();
   }
   catch(error)
   { 
      console.log(error);return {result:false,errors:["Erreur reseaux"]};
   }
} 

function ApiFetch(methode='post',target="",data={})
{
    const settings = localStorage.getItem('settings');
    var lang = 'fr';
    var devise = 'euro';
    if(!!settings)
    {
        const _settings = JSON.parse(settings);
        lang = _settings.lang==='km'?'sw':_settings.lang;
        devise = _settings.devise;
    }
    let hearders = {'Content-Type':'application/json',
      'Accept':'*/*',
      'lang':lang,
      'devise':devise,
    };
    switch(methode)
    {
      case 'post':
        return fetch(serverurl+target, {
          method: 'post',
          headers: hearders,
          credentials: 'include',
          body: JSON.stringify(data)}).then((response)=>{return JsonParse(response)}).catch((error)=>{console.log(error)});;
      case 'get':
        return fetch(serverurl+target,{
          method: 'get',
          credentials: 'include',
          headers: hearders
        }).then((response)=>{console.log(response);return JsonParse(response)}).catch((error)=>{console.log(error)});
      case 'put':
        return fetch(serverurl+target,{
          method: 'put',
          headers: hearders,
          credentials: 'include',
          body: JSON.stringify(data)}).then((response)=>{return JsonParse(response)}).catch((error)=>{console.log(error)});;
      case 'delete':
        return fetch(serverurl+target,{
          method: 'delete',
          credentials: 'include',
          headers: hearders,
          body: JSON.stringify(data)}).then((response)=>{return JsonParse(response)}).catch((error)=>{console.log(error)});;
      default:
        return
    }
}


export function useFetch()
{
  const [error,setError] = useState("");
  useEffect(()=>{
  },[error]);

  const LogOut = useCallback(async (UserState,setUserState)=>{
      //setUserState({...UserState,auth:false,is_staff:false,labelname:"Espace Client"});
      //const refreshtoken = sessionStorage.getItem('refreshtoken');
      return ApiFetch('post', 'user/logout/',{}).finally(()=>{
        setUserState({...UserState,auth:false,is_staff:false,labelname:"Espace Client"});
        //sessionStorage.removeItem('accesstoken');
        //sessionStorage.removeItem('refreshtoken');
      });
  },[])

  const RefreshToken = useCallback(async (refreshtoken,UserState,setUserState)=>{
    return ApiFetch('post','user/login/refresh/',{}).then((token)=>{
      }).catch((error)=>console.log(error));
  },[])

  const Authenticate = useCallback((UserState,setUserState) => {
            ApiFetch('get',`user/authentication/`).then((result)=>{
              console.log('authentication',result);
              if(!result.result)
                {
                  LogOut(UserState,setUserState);
                }
                else
                {
                  if(!UserState.auth)
                  {GetAppUser(UserState,setUserState);}
                }
                
            }).catch((error)=>{console.log(error);});
        /*
          }
        else if(isExpired(token))
        {
            const refreshtoken = sessionStorage.getItem('refreshtoken');
            if(!!refreshtoken && !isExpired(refreshtoken))
            {RefreshToken(refreshtoken,UserState,setUserState);}
            else
            {LogOut(UserState,setUserState);}
        }*/
    //}
    //else
    //{LogOut(UserState,setUserState);}
  }, []);

  const PostData = useCallback(async (data,target='user')=>
    {
        return ApiFetch('post',target,data);
  },[]);

  const PutData = useCallback(async (data,target='user')=>{
       return ApiFetch('put',target, data);
  },[]);

  const DeleteData = useCallback(async (data,target='user')=>{
    return ApiFetch('delete',target, data);
  },[]);

  const PostFormData = useCallback(async (FormData,target)=>
    {
        const settings = localStorage.getItem('settings');
        var lang = 'fr';
        var devise = 'EUR';
        if(!!settings)
        {
            const _settings = JSON.parse(settings);
            lang = _settings.lang;
            devise = _settings.devise;
        }
        let hearders = {'Accept':'*/*','lang':lang,'devise':devise};
        return fetch(serverurl+target,{
          method:'post',
          headers:hearders,
          body: FormData
        }).then((response)=>{return JsonParse(response)});
  },[])

  const PutFormData = useCallback(async (FormData,target)=>
    {
        const settings = localStorage.getItem('settings');
        var lang = 'fr';
        var devise = 'EUR';
        if(!!settings)
        {
            const _settings = JSON.parse(settings);
            lang = _settings.lang;
            devise = _settings.devise;
        }
        let hearders = {'Accept':'*/*','lang':lang,'devise':devise};
        return fetch(serverurl+target,{
          method:'put',
          headers:hearders,
          body: FormData
        }).then((response)=>{return JsonParse(response)});
  },[])

  const GetData = useCallback(async (url)=>
  {
      return ApiFetch('get',url);
  },[]);

  const GetAppUser = useCallback(async (UserState,setUserState)=>{
      let _panier = {articles:[]};
      UserState.panier.articles.forEach((item) => {
          //console.log(item);
          _panier.articles.push({article:{id:item.article.id},quantity:item.quantity,location_dates:item.location_dates});
      });
      PostData(_panier,'user/login/profile/').then((res)=>
      {
          if(!!res.user)
            setUserState({...res.user});
          else
            setError("Erreur de connexion");;
      }).catch((error)=>{setError("Erreur de connexion");});
  },[])

  const LoginAuth = useCallback(async (loginData,UserState,setUserState) => {
    if(!UserState.auth)
    {
        PostData(loginData,'user/login/').then((result)=>
        { 
           if(result.result)
           {
              GetAppUser(UserState,setUserState);
              setError(0);
           }
           else
           {setError(result.error);}
           return result.error;
      }).catch((error)=>{setError("Erreur de connexion"); return "Erreur de connexion";});
    }
}, []);


  return ({'PostFormData':PostFormData,
    'PutFormData': PutFormData,
    'PostData':PostData,
    'DeleteData':DeleteData,
    'PutData':PutData,
    'GetData':GetData,
    'Authenticate':Authenticate,
    'Login':LoginAuth,
    'LogOut':LogOut,
    'error':error
  });
}

export const FetchData=()=>{};
